import { Component, Input } from '@angular/core';

@Component({
  selector: 'globot-information-section',
  template: `
    <div class="container-center">
      <img src="/assets/img/customer_support.svg" alt="customer globot" />
      <h1 class="mt-5">{{ title }}</h1>
      <p>{{ message }}</p>
    </div>
  `,
  styleUrls: ['./information-section.component.scss'],
})
export class InformationSectionComponent {
  @Input() title: string = '';
  @Input() message: string = 'No hay información';
}
